import PrimaryCard from "../common/cards/PrimaryCard";
import React, { useCallback, useState } from "react";
import { Grid, GridItem, HStack, VStack } from "@chakra-ui/react";

import { OccupantIcon } from "../common/icons";
import { useTranslation } from "react-i18next";
import SeatCard from "./SeatCard";
import { useVehicle } from "../../hooks";
import { PrimaryTag } from "../common/tags";
import KidIcon from "../common/icons/KidIcon";

const OccupantsCard = () => {
    const { t } = useTranslation();
    const { occupants, occupantsCount, kidsCount } = useVehicle();
    const [isHovering, setIsHovering] = useState(false);

    const onMouseEnter = useCallback(() => {
        setIsHovering(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setIsHovering(false);
    }, []);

    return (
        <PrimaryCard
            id={"occupants-card"}
            title={t("plugin.occupants.title")}
            _before={{
                backgroundImage: "url(/car.png)",
                backgroundSize: "cover",
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                transition: "linear .2s",
                transform: isHovering ? "scale(1)" : "scale(.9)",
                opacity: isHovering ? .4 : 0,
            }}
            minWidth={"380px"}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <VStack width={"full"} height={"full"}>
                <HStack width={"full"} zIndex={1}>
                    <PrimaryTag icon={OccupantIcon} padding={"10px"} fontSize={"12px"} fontWeight={300}>
                        {occupantsCount} occupants
                    </PrimaryTag>
                    <PrimaryTag icon={KidIcon} padding={"10px"} fontSize={"12px"} fontWeight={300}>
                        {kidsCount} {t("plugin.occupants.kid") + (kidsCount > 1 ? "s" : "")}
                    </PrimaryTag>
                </HStack>
                <Grid width={"full"} height={"full"} templateColumns={"repeat(6, 1fr)"} templateRows={"repeat(2, 1fr)"} gap={"6px"}>
                    <GridItem colStart={1} colSpan={3} rowStart={1} rowSpan={1}>
                        <SeatCard occupant={occupants?.Row1?.DriverSide} row={"Row1"} seat={"DriverSide"} />
                    </GridItem>
                    <GridItem colStart={4} colSpan={3} rowStart={1} rowSpan={1}>
                        <SeatCard occupant={occupants?.Row1?.PassengerSide} row={"Row1"} seat={"PassengerSide"} />
                    </GridItem>
                    <GridItem colStart={1} colSpan={3} rowStart={2} rowSpan={1}>
                        <SeatCard occupant={occupants?.Row2?.Middle} row={"Row2"} seat={"Middle"} />
                    </GridItem>
                    <GridItem colStart={4} colSpan={3} rowStart={2} rowSpan={1}>
                        <SeatCard occupant={occupants?.Row2?.PassengerSide} row={"Row2"} seat={"PassengerSide"} />
                    </GridItem>
                </Grid>
            </VStack>
        </PrimaryCard>
    );
};

export default React.memo(OccupantsCard);